var map = {
	"./": 51,
	"./App": 58,
	"./App.js": 58,
	"./UI/colors": 2,
	"./UI/colors.js": 2,
	"./assets/animation/pikachu": 61,
	"./assets/animation/pikachu.json": 61,
	"./assets/animation/pokemon-loading": 62,
	"./assets/animation/pokemon-loading.json": 62,
	"./assets/img/background-pokeball.png": 81,
	"./assets/img/background-pokedex.png": 82,
	"./assets/svg/details.svg": 141,
	"./assets/svg/open-pokeball.svg": 142,
	"./assets/svg/pokeball-color.svg": 143,
	"./assets/svg/pokeball.svg": 144,
	"./assets/svg/pokebola.svg": 145,
	"./assets/svg/pokedex.svg": 83,
	"./components/CardDetails": 37,
	"./components/CardDetails/": 37,
	"./components/CardDetails/index": 37,
	"./components/CardDetails/index.jsx": 37,
	"./components/CardPokedex": 41,
	"./components/CardPokedex/": 41,
	"./components/CardPokedex/index": 41,
	"./components/CardPokedex/index.jsx": 41,
	"./components/CardPokemon": 43,
	"./components/CardPokemon/": 43,
	"./components/CardPokemon/index": 43,
	"./components/CardPokemon/index.jsx": 43,
	"./components/ImgLoadingSprites": 18,
	"./components/ImgLoadingSprites/": 18,
	"./components/ImgLoadingSprites/index": 18,
	"./components/ImgLoadingSprites/index.jsx": 18,
	"./components/NavMenu": 23,
	"./components/NavMenu/": 23,
	"./components/NavMenu/index": 23,
	"./components/NavMenu/index.jsx": 23,
	"./index": 51,
	"./index.js": 51,
	"./pages/Error404": 38,
	"./pages/Error404/": 38,
	"./pages/Error404/index": 38,
	"./pages/Error404/index.jsx": 38,
	"./pages/Home": 42,
	"./pages/Home/": 42,
	"./pages/Home/index": 42,
	"./pages/Home/index.jsx": 42,
	"./pages/Pokedex": 39,
	"./pages/Pokedex/": 39,
	"./pages/Pokedex/index": 39,
	"./pages/Pokedex/index.jsx": 39,
	"./routes": 59,
	"./routes.js": 59,
	"./services/api": 19,
	"./services/api.js": 19,
	"./services/links": 60,
	"./services/links.json": 60,
	"./services/pokedex": 20,
	"./services/pokedex.js": 20,
	"./styles/GlobalStyle": 63,
	"./styles/GlobalStyle.js": 63,
	"./styles/components/CardDetails": 27,
	"./styles/components/CardDetails/": 27,
	"./styles/components/CardDetails/index": 27,
	"./styles/components/CardDetails/index.js": 27,
	"./styles/components/CardPokemon": 7,
	"./styles/components/CardPokemon/": 7,
	"./styles/components/CardPokemon/index": 7,
	"./styles/components/CardPokemon/index.js": 7,
	"./styles/components/NavMenu": 36,
	"./styles/components/NavMenu/": 36,
	"./styles/components/NavMenu/index": 36,
	"./styles/components/NavMenu/index.js": 36,
	"./styles/pages": 8,
	"./styles/pages/": 8,
	"./styles/pages/Error404": 28,
	"./styles/pages/Error404/": 28,
	"./styles/pages/Error404/index": 28,
	"./styles/pages/Error404/index.js": 28,
	"./styles/pages/Home": 16,
	"./styles/pages/Home/": 16,
	"./styles/pages/Home/index": 16,
	"./styles/pages/Home/index.js": 16,
	"./styles/pages/Pokedex": 40,
	"./styles/pages/Pokedex/": 40,
	"./styles/pages/Pokedex/index": 40,
	"./styles/pages/Pokedex/index.js": 40,
	"./styles/pages/index": 8,
	"./styles/pages/index.js": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;